// extracted by mini-css-extract-plugin
export default {"headerBar":"yH-z","pointsSection":"zH-z","goToDashboard":"AH-z"};